exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".copy_right[data-v-24d25cc4]{line-height:30px;text-align:center;color:#dcdcdc}\n", ""]);

// exports
